exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status-note[data-v-b51d1b38] {\n  border-top: 1px solid #5e71e4;\n  border-bottom: 1px solid #5e71e4;\n  padding: 6px;\n}\n.input-switcher[data-v-b51d1b38] {\n  position: absolute;\n  /*bottom: -28px;*/\n  left: 20px;\n  font-size: 12px;\n  color: var(--primary-color);\n  cursor: pointer;\n}\n.mt-10[data-v-b51d1b38] {\n  margin-top: 10px;\n}\n", ""]);

// exports
